module.exports = __webpack_public_path__ + "img/ipadpro1_splash.8a4f8af0.png";